const {
	REACT_APP_API_URL = '',
	REACT_APP_API_PRE_CHECK_URL = '',
	REACT_APP_API_LOGIN_URL = '',
	REACT_APP_API_OTP_URL = '',
	REACT_APP_API_OTP_RESEND_URL = '',
	REACT_APP_API_PIN_URL = '',
	REACT_APP_API_CODE_URL = '',
	REACT_APP_API_FORGOT_PIN_URL = '',
	REACT_APP_API_RESET_PIN_URL = '',
	REACT_APP_API_ACCEPT_TNC = ''
} = process.env;
// const REACT_APP_API_URL = 'https://03d5-106-51-86-180.in.ngrok.io';
export const PRECHECKAPI = REACT_APP_API_URL + REACT_APP_API_PRE_CHECK_URL;
export const LOGINAPI = REACT_APP_API_URL + REACT_APP_API_LOGIN_URL;
export const VALIDATEOTP = REACT_APP_API_URL + REACT_APP_API_OTP_URL;
export const RESENDOTP = REACT_APP_API_URL + REACT_APP_API_OTP_RESEND_URL;
export const PINAPI = REACT_APP_API_URL + REACT_APP_API_PIN_URL;
export const CODEAPI = REACT_APP_API_URL + REACT_APP_API_CODE_URL;
export const FORGOT_PIN = REACT_APP_API_URL + REACT_APP_API_FORGOT_PIN_URL;
export const RESET_PIN = REACT_APP_API_URL + REACT_APP_API_RESET_PIN_URL;
export const ACCEPT_TNC = REACT_APP_API_URL + REACT_APP_API_ACCEPT_TNC;
export const TEMPAPI = 'https://httpbin.org/anything';
